<!-- Navbar -->
<mdb-navbar [SideClass]="sideClass" [containerInside]="false">
  <mdb-navbar-brand>
    <jhi-bary-page-header></jhi-bary-page-header>
  </mdb-navbar-brand>

  <!-- SideNav slide-out button -->
  <navlinks class="navbar-container">
    <!-- SideNav slide-out button -->
    <div class="float-left">
      <a (click)="handleToggleSideBar()" class="button-collapse">
        <jhi-bary-icon icon="bars" [faDirective]="FAS"></jhi-bary-icon>
      </a>
    </div>
    <!--/. SideNav slide-out button -->
  </navlinks>
  <!--/. SideNav slide-out button -->

  <ul class="navbar-nav ml-auto nav-flex-icons ml-auto">
    <jhi-bary-notification *ngIf="hasNotifications()" [pagination]="notifications.pagination" [notifications]="notifications.content"></jhi-bary-notification>
    <li class="nav-item" *ngIf="hasBasket()">
      <a class="nav-link waves-light" (click)="handleGoTo(PATHS.ORDER_BASKET.path)" mdbWavesEffect>
        <jhi-bary-icon icon="shopping-cart" [faDirective]="FAS" size="lg" class="grey-text"></jhi-bary-icon>
        <span class="count" *ngIf="basket?.transports?.length && basket?.transports?.length! > 0"> {{ basket?.transports?.length }}</span>
      </a>
    </li>
    <!-- profile -->
    <li class="nav-item dropdown" dropdown>
      <a dropdownToggle type="button" data-id-cypress="profile" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
        <jhi-bary-icon icon="user-circle" [faDirective]="FAS" size="lg" class="grey-text"></jhi-bary-icon>
        <span class="d-none d-inline" data-id-cypress="name-user">{{ user?.firstName }} {{ user?.lastName }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right" role="menu">
        <a class="dropdown-item waves-light" (click)="handleGoTo(PATHS.USER_MY_ACCOUNT.path)" mdbWavesEffect data-id-cypress="my-account">
          <jhi-bary-icon icon="user" [faDirective]="FAS" class="fas-fw mr-1"></jhi-bary-icon>
          <span jhiTranslate="global.menu.account.myAccount">My Account</span>
        </a>
        <a class="dropdown-item waves-light" (click)="handleLogout()" mdbWavesEffect data-id-cypress="logout">
          <jhi-bary-icon icon="sign-out-alt" [faDirective]="FAS" class="fas-fw mr-1"></jhi-bary-icon>
          <span jhiTranslate="global.menu.account.logout">Disconnect</span>
        </a>
      </div>
    </li>
  </ul>
</mdb-navbar>
<!--/. Navbar -->
